import axios from 'axios';
import Metadata from '../helpers/metadata/Metadata';
import recordDescriptorProcessing  from '../helpers/StoreFunctions/recordDescriptorProcessing';
import serviceUtil from './serviceUtil';

let helpers = {
  getCustomer: (customer_id, options) => {
    let url = process.env.REACT_APP_API +
      '/customers/' + customer_id + '&current_company=' +
      localStorage.current_company_id;
    if (options && options.recordDescriptor) {
      url += '&filtering=' + recordDescriptorProcessing.getEncodedForFastSerializer(options.recordDescriptor);
    }
  
    return axios({
      method: 'get',
      url: url,
      headers: {
        Authorization: 'Token token=' + localStorage.token,
      },
    })
      .then(response => {
        return response.data;
      })
      .catch(error => {
        return serviceUtil.resultForError(error);
      });
  },
  getCustomers: (company_id, options) => {
    let url = process.env.REACT_APP_API +
      '/customers?current_company=' +
      company_id;
    if (options && options.recordDescriptor) {
      url += '&filtering=' + recordDescriptorProcessing.getEncodedForFastSerializer(options.recordDescriptor);
    }
  
    return axios({
      method: 'get',
      url: url,
      headers: {
        Authorization: 'Token token=' + localStorage.token,
      },
    })
      .then(response => {
        return response.data;
      })
      .catch(error => {
        return serviceUtil.resultForError(error);
      });
  },
  createCustomer: (customer, eventMetadatum) => {
    if (!eventMetadatum) {
      eventMetadatum = Metadata.generateMetadatum();
    }
    return axios({
      method: 'post',
      url:
        process.env.REACT_APP_API +
        '/customers?current_company=' +
        localStorage.current_company_id,
      data: {
        eventMetadatum: eventMetadatum,
        customer: customer,
      },
      timeout: 60000,
      headers: {
        'Content-Type': 'application/json',
        Authorization: 'Token token=' + localStorage.token,
      },
    })
      .then(response => {
        return response.data;
      })
      .catch(error => {
        return serviceUtil.resultForError(error);
      });
  },
  updateCustomer(customer, eventMetadatum){
    if (!eventMetadatum) {
      eventMetadatum = Metadata.generateMetadatum();
    }
    return axios({
      method: 'patch',
      url: `${process.env.REACT_APP_API}/customers/${customer.id}?current_company=${localStorage.current_company_id}`,
      timeout: 20000, headers: {
        'Content-Type': 'application/json',
        'Accept': '*/*',
        'Authorization': 'Token token=' + localStorage.token,
      },
      data: {
        event_metadatum: eventMetadatum,
        customer: customer,
      },
    })
      .then(response => {
        return response.data;
      })
      .catch(error => {
        return serviceUtil.resultForError(error);
      });
  },
  deleteCustomer: (customer_id, eventMetadatum) => {
    if (!eventMetadatum) {
      eventMetadatum = Metadata.generateMetadatum();
    }
    return axios({
      method: 'delete',
      url:
        process.env.REACT_APP_API +
        '/customers/' +
        customer_id +
        '?current_company=' +
        localStorage.current_company_id,
      timeout: 20000,
      data: {
        eventMetadatum: eventMetadatum,
      },
      headers: {
        'Content-Type': 'application/json',
        Authorization: 'Token token=' + localStorage.token,
      },
    })
      .then(response => {
        return response;
      })
      .catch(error => {
        return serviceUtil.resultForError(error);
      });
  },
};

export default helpers;



// WEBPACK FOOTER //
// ./src/services/customersService.js